import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LayoutContainer from '../../components/LayoutContainer';
import Box from '../../components/Box';
import Button from '../../components/Button';
import MainContainer from '../../components/MainContainer';
import Logo from '../../components/Logo';
import {destroySession} from '../../reducer';
import Title from '../../components/Title';
import useScrollToTop from '../../hooks/useScrollToTop';
import Teaser from '../../components/Teaser';
import {withTheme} from 'styled-components';
import DJSBSideBar from '../../components/DJSBSideBar';

const DonationAlreadyCompleted = ({formContext, startNewLead, history, theme}) => {
  useScrollToTop();
  return <>
    <MainContainer
      backgroundImageUrl={formContext.backgroundImageUrl}
      backgroundImageTabletUrl={formContext.backgroundImageTabletUrl}
      backgroundImageMobileUrl={formContext.backgroundImageMobileUrl}
    />
    <LayoutContainer
      position={formContext.textPosition}
      header={<div>
        <div style={{float: 'left', display: 'inline-block'}}>
          <Logo url={formContext.websiteUrl} />
        </div>
      </div>}
      content={<><Box position={formContext.textPosition}
        hasTeaser={!_.isNil(formContext.pageTeaserHeader) || !_.isNil(formContext.pageTeaserBodyText) || !_.isEmpty(formContext.pageTeaserCarouselItems)}>
        {!theme?.title?.showInBody && <Title title={formContext.step1Header} />}
        <div className='widgetContent invalidFlow'>
          <h1>Bedankt voor je aanvraag</h1>
          <p>Je aanvraag is succesvol afgerond. Middels onderstaande knop kan je een nieuwe aanvraag starten.
          </p>
          <Button label='Start nieuwe aanvraag' onClick={() => {
            startNewLead(history);
          }} />
        </div>
      </Box>
        {formContext.allowCallToAction &&
        <div dangerouslySetInnerHTML={{__html: formContext.callToAction}} />}
      </>}
      sidebar={<>
        {theme?.djsb?.showDJSB && <DJSBSideBar formContext={formContext}/>}
        <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} />
      </>}
      footer={formContext.footer}
      formContext={formContext}
    />

  </>;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext
  };
};

const mapDispatchToProps = (dispatch) => ({
  startNewLead: (history) => {
    dispatch(destroySession(history));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTheme(DonationAlreadyCompleted)));
